import { type TFunction } from 'react-i18next';
import { boolean, object, string } from 'yup';

import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { type CustomerDetails } from '@service-initiation/tech-care-data-access-store';

const INVALID_MESSAGE = "That doesn't look right. Please try again.";
const MIN_NAME_LENGTH = 2;

const TEXT = TranslationEntries.Repairs.CustomerDetails.Form.Error;

export const customerDetailsFormSchema = (
  t?: TFunction<'translation', undefined>
) => {
  return object<CustomerDetails>({
    agreeToEmailOffers: boolean(),
    confirmed: boolean(),
    email: string()
      .required(t ? t(TEXT.EmailRequired) : 'Email address is required')
      .email(t ? t(TEXT.EmailInvalid) : INVALID_MESSAGE),
    firstName: string()
      .required(t ? t(TEXT.FirstNameRequired) : 'First name is required')
      .min(
        MIN_NAME_LENGTH,
        t ? t(TEXT.FirstNameInvalid) : 'First name should be longer.'
      ),
    lastName: string()
      .required(t ? t(TEXT.LastNameRequired) : 'Last name is required')
      .min(
        MIN_NAME_LENGTH,
        t ? t(TEXT.LastNameInvalid) : 'Last name should be longer.'
      ),
    phoneNumber: string()
      .required(t ? t(TEXT.PhoneNumberRequired) : 'Phone number is required')
      .test(
        'phone',
        t ? t(TEXT.PhoneNumberInvalid) : INVALID_MESSAGE,
        (value) => {
          const digitsOnly = value?.replace(/\D/g, '');
          const mdnRegEx = RegExp(/^[1-9]\d{9}$/);
          const hasTenDigits = digitsOnly ? mdnRegEx.test(digitsOnly) : false;
          return (value && value?.length > 0 && hasTenDigits) || false;
        }
      ),
  });
};
